import { extendObservable, action } from 'mobx';

const stripeNameMap = {
  name: "name",
  addressLine1: "address_line1",
  addressLine2: "address_line2",
  addressCity: "address_city",
  addressStateProv: "address_state",
  addressZip: "address_zip",
  addressCountry: "address_country",
}
export class CreditCardOwnerInfo {
  constructor({
    name = "",
    addressLine1 = "",
    addressLine2 = "",
    addressCity = "",
    addressStateProv = "",
    addressZip = "",
    addressCountry = "",
  } = {}) {

    extendObservable(this, {
      name,
      addressLine1,
      addressLine2,
      addressCity,
      addressStateProv,
      addressZip,
      addressCountry,
    });
  }

  isValid = () => {
    for (const key in this) {
      if (key === "addressLine2") {
        continue;
      }
      
      if (!this[key]) {
        return false;
      }
    }
    return true;
  }

  set = action((props = {}) => {
    for (let key in props) {
      this[key] = props[key];
    }
  });

  get = () => {
    return JSON.parse(JSON.stringify(this));
  }

  getForStripe = () => {
    let ret = {};
    for (let key in this) {
      const stripeKey = stripeNameMap[key];
      ret[stripeKey] = this[key];
    }
    return ret;
  }
}

export default CreditCardOwnerInfo;


// WEBPACK FOOTER //
// ./src/models/CreditCardOwnerInfo.js